"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLibzipPromise = exports.getLibzipSync = void 0;
const tslib_1 = require("tslib");
const instance_1 = require("./instance");
const libzipSync_1 = tslib_1.__importDefault(require("./libzipSync"));
const makeInterface_1 = require("./makeInterface");
tslib_1.__exportStar(require("./common"), exports);
(0, instance_1.setFactory)(() => {
    const emZip = (0, libzipSync_1.default)();
    return (0, makeInterface_1.makeInterface)(emZip);
});
function getLibzipSync() {
    return (0, instance_1.getInstance)();
}
exports.getLibzipSync = getLibzipSync;
async function getLibzipPromise() {
    return (0, instance_1.getInstance)();
}
exports.getLibzipPromise = getLibzipPromise;
